import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../services/util.service';

@Pipe({
  name: 'datetime',
})
export class DatetimePipe implements PipeTransform {

  constructor(
    private util: UtilService
  ) {}

  transform(value: string | Date): string {
    if (!(value instanceof Date)) {
      value = new Date(value)
    }
    return this.util.DateTimeToString(value)
  }

}
